import {User} from "../api/user.ts";
import {createContext, useContext, useState} from "react";

export interface UserContextType {
    user: User | null;
    setUser: (user: User | null) => void;
}

export const UserContext = createContext<UserContextType>({
    user: null,
    setUser: () => {}
});

export const useNewUserContext = (): UserContextType => {
    const [user, setUser] = useState<User | null>(null);

    return {user, setUser};
}

export const useUser = (): User | null => {
    return useContext(UserContext).user;
}

export const useUserContext = (): UserContextType => {
    return useContext(UserContext);
}